import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const MaintenanceIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={className}
        data-testid={testId}
        fill='none'
        height='28'
        viewBox='0 0 30 30'
        width='28'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M29.4137 6.32035C29.2839 5.79723 28.6293 5.61996 28.2481 6.00115L23.9403 10.3089L20.0079 9.65373L19.3527 5.72134L23.6605 1.41356C24.044 1.03006 23.8592 0.376591 23.3326 0.245666C20.5878 -0.434449 17.5655 0.298383 15.4203 2.443C13.1239 4.73941 12.4919 8.06814 13.4478 10.9705L1.08578 23.3325C-0.361927 24.7802 -0.361927 27.1276 1.08578 28.5753C2.53349 30.023 4.88087 30.023 6.32857 28.5753L18.6801 16.2237C21.5837 17.1918 24.906 16.5528 27.2175 14.2413C29.365 12.0938 30.0967 9.06688 29.4137 6.32035ZM3.70776 27.3437C2.94016 27.3437 2.3174 26.7209 2.3174 25.9533C2.3174 25.1851 2.94016 24.563 3.70776 24.563C4.47535 24.563 5.09811 25.1851 5.09811 25.9533C5.09811 26.7209 4.47535 27.3437 3.70776 27.3437Z'
            fill='currentColor'
        />
    </svg>
);

export default MaintenanceIcon;
